


















































import { Vue, Component, Prop } from "vue-property-decorator"
import VideoOnVideoInfo from "../../models/VideoOnVideoInfo"
const shaka = require("shaka-player/dist/shaka-player.ui")
import replaceHtmlClass from "../../services/replaceHtmlClass"
import "shaka-player/dist/controls.css"
import "../../assets/plyr.css"
import "../../assets/vendor/bootatrap-grid.css"
import "../../assets/_base.scss"
import "../../assets/pipwidget.css"
import SwapButton from "../VideoPlayerCustomButtons/SwapButton"
import { VideoInfo } from "../../models/VideoInfo"
var SocialSharing = require("vue-social-sharing")
Vue.use(SocialSharing)
import CaptionButton from "../VideoPlayerCustomButtons/CaptionButton"
import loadDuration from "../../services/loadDuration"
import { EventBus } from "../../event-bus"
interface videoElement extends HTMLVideoElement {
  requestPictureInPicture(): any
  disablePictureInPicture: any
}
interface Doc extends Document {
  pictureInPictureEnabled: any
  pictureInPictureElement: any
  exitPictureInPicture(): any
}

@Component
export default class extends Vue {
  @Prop() private momentsData!: VideoOnVideoInfo
  private get baseVideo(): HTMLVideoElement {
    return this.$refs.baseVideo as HTMLVideoElement
  }
  private get pipVideo(): videoElement {
    return this.$refs.pipVideo as videoElement
  }

  private get baseContainer(): HTMLElement {
    return this.$refs.baseContainer as HTMLElement
  }
  private get pipContainer(): HTMLElement {
    return this.$refs.pipContainer as HTMLElement
  }
  private get pipWidget(): HTMLElement {
    return this.$refs.pipSubWidget as HTMLElement
  }
  private get workarround(): HTMLElement {
    return this.$refs.thisToBody as HTMLElement
  }
  private get doc(): Doc {
    return document as Doc
  }

  baseVideoData: VideoInfo = this.momentsData.video_big
  pipVideoData: VideoInfo = this.momentsData.video_small
  stright: boolean = true
  currentTime: number = 0
  timeoutId = 0
  isposter = true
  ispipPoster = true
  miniposter: string = this.momentsData.video_small.poster_url
  //shaka ui
  durationElement?: HTMLElement
  playbuttonElement?: HTMLElement
  bottomControlElement?: HTMLElement
  skimElement?: HTMLElement
  seekbarelement?: HTMLElement
  seekbarbufferedelement?: HTMLElement
  shakacontrolsContainerElement?: HTMLElement
  seektimeout = 0
  created() {
    EventBus.$on("pip-load-event", this.updateMomentId)
  }
  mounted() {
    shaka.polyfill.installAll()
    const baseplayer = new shaka.Player(this.baseVideo)
    const pipPlayer = new shaka.Player(this.pipVideo)
    var self = this
    SwapButton.Factory = class {
      create(rootElement: any, controls: any) {
        return new SwapButton(
          rootElement,
          controls,
          self.onSwap,
          baseplayer,
          pipPlayer
        )
      }
    }
    CaptionButton.Factory = class {
      create(rootElement: any, controls: any) {
        return new CaptionButton(rootElement, controls, baseplayer)
      }
    }
    // Register our factory with the controls, so controls can create button instances.
    shaka.ui.Controls.registerElement("swap", new SwapButton.Factory())
    shaka.ui.Controls.registerElement("captions", new CaptionButton.Factory())
    //load base video
    const uiConfig = {
      controlPanelElements: [
        "play_pause",
        "time_and_duration",
        "mute",
        "volume",
        "captions",
        "swap",
        "fullscreen"
      ],
      addSeekBar: true,
      doubleClickForFullscreen: false
    }
    const ui = new shaka.ui.Overlay(
      baseplayer,
      this.baseContainer,
      this.baseVideo
    )
    ui.configure(uiConfig)
    let controls = ui.getControls()

    controls
      .getControlsContainer()
      .getElementsByClassName("shaka-mute-button")[0]
      .addEventListener("click", this.onMuted)
    //load pip video
    const pipUiConfig = {
      controlPanelElements: [""],
      addSeekBar: false,
      addBigPlayButton: false
    }
    const pipUi = new shaka.ui.Overlay(
      pipPlayer,
      this.pipContainer,
      this.pipVideo
    )
    pipUi.configure(pipUiConfig)
    if (shaka.Player.isBrowserSupported()) {
      baseplayer.configure({
        abr: {
          defaultBandwidthEstimate: 640000000 // 8 MB/s or 64e7 bits/s
        },
        streaming: {
          jumpLargeGaps: true,
          bufferingGoal: 120,
          failureCallback: () => {
            console.error("Video Buffering failed")
          }
        }
      })
      pipPlayer.configure({
        abr: {
          defaultBandwidthEstimate: 640000000 // 8 MB/s or 64e7 bits/s
        },
        streaming: {
          jumpLargeGaps: true,
          bufferingGoal: 120,
          failureCallback: () => {
            console.error("Video Buffering failed")
          }
        }
      })
      this.loadPlayers(
        baseplayer,
        this.baseVideoData.dash_url,
        pipPlayer,
        this.pipVideoData.dash_url,
        0
      ).then(() => {
        ui.getControls()
          .getControlsContainer()
          .getElementsByClassName("shaka-seek-bar-container")[0]
          .classList.add("not-on-iphone")
      })
    }
    document.getElementsByTagName("body")[0].appendChild(this.workarround)
    this.durationElement = loadDuration(
      controls.getControlsContainer() as HTMLElement,
      this.momentsData.duration
    )
    this.playbuttonElement = (controls.getControlsContainer() as HTMLElement).getElementsByClassName(
      "shaka-play-button-container"
    )[0] as HTMLElement
    this.bottomControlElement = (controls.getControlsContainer() as HTMLElement).getElementsByClassName(
      "shaka-bottom-controls"
    )[0] as HTMLElement
    this.bottomControlElement.classList.add("hide")
    this.skimElement = (controls.getControlsContainer() as HTMLElement).getElementsByClassName(
      "shaka-skim-container"
    )[0] as HTMLElement
    this.skimElement.classList.add("hide")
    this.shakacontrolsContainerElement = controls.getControlsContainer() as HTMLElement
    this.shakacontrolsContainerElement.classList.add("opaque")
    this.seekbarelement = document.createElement("div")
    this.seekbarelement.classList.add("shaka-seek")
    this.seekbarbufferedelement = document.createElement("div")
    this.seekbarbufferedelement.classList.add("shaka-seek-buffered")
    ;((controls.getControlsContainer() as HTMLElement).getElementsByClassName(
      "shaka-seek-bar-container"
    )[0] as HTMLElement).appendChild(this.seekbarelement)
    ;((controls.getControlsContainer() as HTMLElement).getElementsByClassName(
      "shaka-seek-bar-container"
    )[0] as HTMLElement).appendChild(this.seekbarbufferedelement)
    this.$root.$data.videoPlayers.push(this.baseVideo)
    this.addlisteners()
    this.pipVideo.muted = true
  }
  async loadPlayers(
    baseplayer: any,
    bigurl: string,
    pipPlayer: any,
    pipurl: string,
    currentTime: number
  ) {
    await baseplayer.load(bigurl).then(() => {
      if (!!this.momentsData.subtitle_urls.web_vtt_url) {
        baseplayer.addTextTrack(
          this.momentsData.subtitle_urls.web_vtt_url,
          "English",
          "captions",
          "text/vtt"
        )
      }
      this.baseVideo.currentTime = currentTime
    })
    await pipPlayer.load(pipurl).then(() => {
      this.pipVideo.currentTime = currentTime
    })
  }
  addlisteners() {
    this.baseVideo.addEventListener("play", this.onplayingBase)
    this.pipVideo.addEventListener("play", this.onplayingPip)
    this.baseVideo.addEventListener("pause", this.onpauseBase)
    this.pipVideo.addEventListener("pause", this.onpausePip)
    this.baseVideo.addEventListener("seeked", this.onSeeked)
    this.baseVideo.addEventListener("volumechange", this.onVolumeChange)
  }
  removelisteners() {
    this.baseVideo.removeEventListener("play", this.onplayingBase)
    this.pipVideo.removeEventListener("play", this.onplayingPip)
    this.baseVideo.removeEventListener("pause", this.onpauseBase)
    this.pipVideo.removeEventListener("pause", this.onpausePip)
    this.baseVideo.removeEventListener("seeked", this.onSeeked)
    this.baseVideo.removeEventListener("volumechange", this.onVolumeChange)
  }
  onMuted() {
    if (this.stright) {
      this.pipVideo.muted = true
      this.baseVideo.muted = !this.baseVideo.muted
    } else {
      this.pipVideo.muted = true
    }
  }
  onVolumeChange() {
    this.pipVideo.volume = this.baseVideo.volume
    if (this.stright) {
      this.pipVideo.muted = true
    } else {
      this.baseVideo.muted = true
    }
  }
  onSeeked() {
    if (this.baseVideo.currentTime < this.pipVideo.duration) {
      this.pipVideo.currentTime = this.baseVideo.currentTime
    } else {
      this.pipVideo.currentTime = this.pipVideo.duration
    }
  }
  onplayingPip() {
    if (
      !isFinite(this.pipVideo.duration) ||
      !isFinite(this.baseVideo.duration)
    ) {
      this.pipVideo.pause()
      this.baseVideo.pause()
      return
    }
    EventBus.$emit("pip-load-event", String(this.momentsData.id))
    if (this.pipVideo.currentTime < this.baseVideo.duration) {
      this.baseVideo.currentTime = this.pipVideo.currentTime
      this.baseVideo.play()
      if (this.is_pipEnabled()) {
        replaceHtmlClass(this.pipWidget, "pip-show", "pip-hide")
        this.onPipClick_()
      } else {
        replaceHtmlClass(this.pipWidget, "pip-hide", "pip-show")
      }
      this.isposter = false
      this.ispipPoster = false
    } else {
      this.baseVideo.pause()
    }
  }
  onplayingBase() {
    if (
      !isFinite(this.pipVideo.duration) ||
      !isFinite(this.baseVideo.duration)
    ) {
      this.pipVideo.pause()
      this.baseVideo.pause()
      return
    }
    this.$root.$data.videoPlayers.forEach((player: any) => {
      if (player != this.baseVideo) {
        player.pause()
      }
    })
    if (this.baseVideo.currentTime < this.pipVideo.duration) {
      this.pipVideo.currentTime = this.baseVideo.currentTime
      this.pipVideo.play()
    } else {
      this.pipVideo.currentTime = this.pipVideo.duration
      this.pipVideo.pause()
    }
    if (this.playbuttonElement) {
      this.playbuttonElement.classList.add("hide")
    }
    replaceHtmlClass(this.durationElement, "show", "hide")
    replaceHtmlClass(this.bottomControlElement, "hide", "show")
    replaceHtmlClass(this.skimElement, "hide", "show")
    replaceHtmlClass(this.shakacontrolsContainerElement, "opaque", "")
    this.seektimeout = setTimeout(() => {
      this.updateSeekbar()
    }, 500)
    window.requestAnimationFrame(this.sync)
  }
  onpausePip() {
    this.baseVideo.pause()
    if (this.momentId == this.momentsData.id) {
      this.onPipClose_()
    }
    this.ispipPoster = true
  }
  onpauseBase() {
    this.pipVideo.pause()
    replaceHtmlClass(this.pipWidget, "pip-show", "pip-hide")
    clearTimeout(this.seektimeout)
  }
  updateLoadedIndicator() {
    if (this.seekbarbufferedelement && this.pipVideo.buffered.length > 0) {
      this.seekbarbufferedelement.setAttribute(
        "style",
        `width:${((this.pipVideo.buffered.end(0) - this.pipVideo.currentTime) /
          this.pipVideo.duration) *
          100}% !important`
      )
    }
  }
  updateSeekbar() {
    clearTimeout(this.seektimeout)

    if (this.seekbarelement) {
      this.seekbarelement.setAttribute(
        "style",
        `width:${(this.pipVideo.currentTime / this.pipVideo.duration) *
          100}% !important`
      )
    }
    if (this.seekbarbufferedelement && this.pipVideo.buffered.length > 0) {
      this.seekbarbufferedelement.setAttribute(
        "style",
        `width:${((this.pipVideo.buffered.end(0) - this.pipVideo.currentTime) /
          this.pipVideo.duration) *
          100}% !important`
      )
    }
    this.seektimeout = setTimeout(() => {
      this.updateSeekbar()
    }, 500)
  }
  sync() {
    if (
      this.baseVideo.readyState == 4 &&
      this.pipVideo.readyState == 4 &&
      this.baseVideo.currentTime != this.pipVideo.currentTime
    ) {
      this.pipVideo.currentTime = this.baseVideo.currentTime
    } else {
    }
  }
  onSwap(basePlayer: any, pipPlayer: any) {
    this.currentTime =
      this.baseVideo.currentTime > this.pipVideo.currentTime
        ? this.baseVideo.currentTime
        : this.pipVideo.currentTime
    this.baseVideo.pause()
    this.pipVideo.pause()
    this.onpauseBase()
    this.onpausePip()

    if (this.stright) {
      this.pipVideo.muted = this.baseVideo.muted
      this.baseVideo.muted = true
      this.loadPlayers(
        basePlayer,
        this.pipVideoData.dash_url,
        pipPlayer,
        this.baseVideoData.dash_url,
        this.currentTime
      )
      this.miniposter = this.baseVideoData.poster_url
      this.baseVideo.pause()
      this.pipVideo.pause()
      this.stright = false
    } else {
      this.baseVideo.muted = this.pipVideo.muted
      this.pipVideo.muted = true
      this.loadPlayers(
        basePlayer,
        this.baseVideoData.dash_url,
        pipPlayer,
        this.pipVideoData.dash_url,
        this.currentTime
      )
      this.miniposter = this.pipVideoData.poster_url
      this.stright = true
    }
  }
  beforeDestroy() {
    this.removelisteners()
  }
  private is_pipEnabled() {
    return (
      this.doc.pictureInPictureEnabled && !this.pipVideo.disablePictureInPicture
    )
  }
  private async onPipClick_() {
    try {
      await this.onPipClose_()
      if (!this.doc.pictureInPictureElement) {
        // If you were fullscreen, leave fullscreen first.
        // if (this.doc.fullscreenElement) {
        //   this.doc.exitFullscreen()
        // }
        await this.pipVideo.requestPictureInPicture()
      }
    } catch (error) {
      replaceHtmlClass(this.pipWidget, "pip-hide", "pip-show")
    }
  }
  private async onPipClose_() {
    try {
      if (this.doc.pictureInPictureElement) {
        await this.doc.exitPictureInPicture()
      }
    } catch (error) {}
  }
  momentId = "-10"
  private updateMomentId(id: string) {
    this.momentId = id
  }
}
